import { t } from '@avalara/bat-apps-shared/i18n';
import { AuiIcon, SCol, SRow } from '@avalara/skylab-sdk/react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectState } from '../../../selectors';
import Resources from '../../shared/resources';
import Banner from '../../styled/components/single-column-banner';
import { BlackText } from '../../styled/components/thank-you';

import FreeTrialThankYou from './free-trial';

import MiddleContent from './middle-content';
const ThankYou = () => {
  const {
    account: { isLoggedIn, primaryContactEmail },
    offer: {
      isFreeTrial,
      offerName,
      thankYouContent: { customHeadingText, resourceHeading, resourceContent, topTextContent, icon },
    },
    sharedSignup: {
      signupForm: { email },
    },
  } = useSelector(selectState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (offerName === 'Free Trial') {
    return <FreeTrialThankYou />;
  }

  const getTopTextContent = (text: string) => {
    const emailForCommunication = isLoggedIn ? primaryContactEmail : email;
    return text.replace('[EMAIL]', emailForCommunication);
  };

  const actionText = isFreeTrial ? 'starting your free trial of' : 'purchasing';

  const getHeaderContent = () => {
    if (customHeadingText) {
      return (
        <Banner orange={true} className='flex justify-content-center'>
          <h1
            className='pad-all-md text-center text-xxl font-normal text-white'
            data-ref='offer.custom-thank-you-heading'
          >
            {customHeadingText}
          </h1>
        </Banner>
      );
    }
    if (icon) {
      return <AuiIcon name={icon} alt={t('client.accessibility.thank-you-icon')} />;
    }

    return (
      <Banner orange={true} className='pad-all-lg'>
        <h1 className='text-center text-xxl font-normal text-white' data-ref='offer.thank-you-heading'>
          {t('client.headings.thank-you-for-action-and-offer-name', {
            actionText,
            offerName,
          })}
        </h1>
      </Banner>
    );
  };

  const resourceSectionHeading = resourceHeading || 'In the meantime, discover other compliance tools';

  const hideContent = offerName === 'Avalara Sales Tax Registration' && isLoggedIn;

  return (
    <SRow>
      <SCol span='12'>
        {getHeaderContent()}

        {topTextContent && topTextContent.length > 0 && (
          <div className='flex flex-dir-col align-items-center text-center' data-ref='offer.thank-you.top-text-content'>
            {topTextContent.map((text) => (
              <h2 key={text} className='pad-bottom-md text-center'>
                {getTopTextContent(text)}
              </h2>
            ))}
          </div>
        )}

        {!hideContent && <MiddleContent />}

        {!hideContent && resourceContent && resourceContent.length > 0 && (
          <BlackText>
            <div
              className='flex flex-dir-col align-items-center pad-left-sm pad-right-sm'
              data-ref='offer.thank-you.resource-content'
            >
              <h2 className='text-center pad-top-lg pad-bottom-none'>{resourceSectionHeading}</h2>
              <Resources content={resourceContent} />
            </div>
          </BlackText>
        )}
      </SCol>
    </SRow>
  );
};

export default ThankYou;
